export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/rww-2f38b178a5e03ca79592d91fff283aca.png";